import { useEffect, useMemo, useState } from "react";
import "./ToastMsg.scss";
import { SUCCESS, ERROR_TEXT } from "../../../../../FTTX/GlobalConstant";

const ToastMsg = ({ type, message, onClose, delay = 5000 }) => {
  const [showToast, setShowToast] = useState();
  const msgType = useMemo(() => type.toLowerCase(), [type]);

  useEffect(() => {
    setShowToast(Boolean(message));
    let timeoutId = null;
    if (showToast || message) {
      timeoutId = setTimeout(() => {
        setShowToast(false);
        onClose?.();
      }, delay);
    }
    
    return () => {
      timeoutId && clearTimeout(timeoutId);
    }
  }, [message, showToast]);

  return (
    showToast ? (
      <div className={`toast_wrap ${msgType === ERROR_TEXT ? "toast-error" : msgType === SUCCESS ? "toast-success" : ""}`}>
        <h4>{type} </h4>
        <span className="toastClose" onClick={onClose}>
          ×
        </span>
        <p className="toast-message">{message} </p>
      </div>
    ) : null
  );
};
export default ToastMsg;
